import { render, staticRenderFns } from "./repair-create-base.vue?vue&type=template&id=6a76ac4e"
import script from "./repair-create-base.vue?vue&type=script&lang=js"
export * from "./repair-create-base.vue?vue&type=script&lang=js"
import style0 from "./repair-create-base.vue?vue&type=style&index=0&id=6a76ac4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports